module.exports = __webpack_public_path__ + "images/ab5ce7f15531458ea41b2f7782e31a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/poppankki.png
// module id = 1525
// module chunks = 1